import { Fragment, type ReactNode } from 'react';
import { Text, type TextProps } from '@doist/marketist';
import cn from 'clsx';
import HtmlToReact, { type DOMNode } from 'html-react-parser';
import css from './product-ui-comment.module.css';
type ProductUICommentTextProps = {
  children: string;
};
function transform(node: ReactNode, _: DOMNode, index: number) {
  if (typeof node === 'string') {
    if (node.trim() === '') {
      return <Fragment key={index}>{node}</Fragment>;
    } else {
      return <Paragraph key={index}>{node}</Paragraph>;
    }
  }
  const {
    type,
    props: {
      children
    }
  } = node as JSX.Element;
  if (type === 'p') {
    return <Paragraph key={index}>{children}</Paragraph>;
  } else if (type === 'a') {
    return <Link key={index}>{children}</Link>;
  } else if (type === 'strong') {
    return <Strong key={index}>{children}</Strong>;
  } else {
    return <Fragment key={index}>{node}</Fragment>;
  }
}
function ProductUICommentText({
  children
}: ProductUICommentTextProps) {
  return <span data-sentry-component="ProductUICommentText" data-sentry-source-file="product-ui-comment-text.tsx">
            {HtmlToReact(children, {
      transform: transform
    })}
        </span>;
}
ProductUICommentText.Placeholder = ({
  children
}: {
  children: ReactNode;
}) => {
  return <Paragraph className={css.tertiary}>{children}</Paragraph>;
};
function Paragraph({
  children,
  className,
  ...rest
}: TextProps) {
  return <Text tag="span" size="body-xs" className={cn(css.text, className)} {...rest} data-sentry-element="Text" data-sentry-component="Paragraph" data-sentry-source-file="product-ui-comment-text.tsx">
            {children}
        </Text>;
}
function Link({
  children,
  ...rest
}: {
  children: ReactNode;
}) {
  return <Paragraph className={css.link} {...rest} data-sentry-element="Paragraph" data-sentry-component="Link" data-sentry-source-file="product-ui-comment-text.tsx">
            {children}
        </Paragraph>;
}
function Strong({
  children,
  ...rest
}: {
  children: ReactNode;
}) {
  return <Paragraph className={css.strong} {...rest} data-sentry-element="Paragraph" data-sentry-component="Strong" data-sentry-source-file="product-ui-comment-text.tsx">
            {children}
        </Paragraph>;
}
export { ProductUICommentText };